import { CALL_API } from '../../api';
import * as ActionTypes from './people.actionTypes';
import schema from '../../api/schema';

const apiReadPeople = () => ({
  [CALL_API]: {
    types: [
      ActionTypes.READ_PEOPLE_REQUEST,
      ActionTypes.READ_PEOPLE_SUCCESS,
      ActionTypes.READ_PEOPLE_FAILURE,
    ],
    endpoint: 'people',
    schema: schema.peopleSchema,
    //authorization: true,
  },
});

export const readPeople = () => (dispatch, getState) => {
  if (getState().entities.people.allIds.length > 0) {
    return Promise.resolve();
  }
  return dispatch(apiReadPeople());
};

export const populatePeopleModal = ids => (dispatch, getState) => {
  return dispatch({
    type: ActionTypes.POPULATE_PEOPLE_MODAL,
    payload: {
      ids,
    },
  });
};



// WEBPACK FOOTER //
// ./src/modules/people/people.actions.js